import React, { useState } from 'react';
import { samplePrompts } from '../../data/samplePrompts';
import { PromptFlow } from './PromptFlow';
import { PromptDemo } from './PromptDemo';
import { PromptCard } from './PromptCard';
import { AuthorControl } from './AuthorControl';
export function PromptExplainer() {
  const [active, setActive] = useState(0);
  return <section aria-label="What is a prompt" className="bg-transparent" data-id="element-235" data-mp="3mj2fbvui37kx">
      <div className="mx-auto max-w-5xl px-5 py-12" style={{
      paddingTop: '20px',
      paddingBottom: '24px'
    }} data-id="element-236" data-mp="37ml18wuxfeuo">
        <div className="text-center" data-id="element-237" data-mp="3cnij18c0y6vn">
          <h2 className="font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-238" data-mp="3ckcw9zqvbh33">🤖 What is a prompt?</h2>
          <p className="mx-auto mt-3 max-w-xl text-base text-plum/70" data-id="element-239" data-mp="33m1804dh4vdt">
            It’s a <span className="font-bold text-grape" data-id="element-240" data-mp="33o59kfnwhiax">master instruction optimized for AI.</span>
          </p>
        </div>

        <PromptFlow data-id="element-241" data-mp="11uo2bd3omjgp" />
        <PromptDemo data-id="element-242" data-mp="11v7lsy8zdfwu" />
        <AuthorControl data-id="element-243" data-mp="11td0hitsrls8" />

        <div className="mx-auto mt-14 max-w-3xl" data-id="element-244" data-mp="11twhmxbmi657">
          <h3 className="text-center font-display text-xl font-black text-plum sm:text-2xl" data-id="element-245" data-mp="30hfodnaus92i">📝 Prompt samples</h3>
          <p className="mt-2 text-center text-sm text-plum/60" data-id="element-246" data-mp="2wfavwrw55ihg">Fill in the brackets, copy, and open the prompt in your favorite AI.</p>

          {samplePrompts.length > 1 && <div role="tablist" aria-label="Prompt samples" className="mt-5 flex flex-wrap justify-center gap-2" data-id="element-247" data-mp="3585rsuzpy1uk">
              {samplePrompts.map((sp, i) => <button key={sp.n} role="tab" type="button" aria-selected={active === i} onClick={() => setActive(i)} className={`whitespace-nowrap rounded-full px-4 py-2 text-xs font-bold transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-grape/40 ${active === i ? 'bg-grape-deep text-white ring-1 ring-gold' : 'border border-gold/40 bg-white text-plum/70 hover:text-plum'}`} data-id="element-248" data-mp="2hl624cpssc7f" data-mpi={i}>
                  #{sp.n} · {sp.title}
                </button>)}
            </div>}

          <div className="mt-5" data-id="element-249" data-mp="dt6wmi4b3kf4">
            <PromptCard key={samplePrompts[active].n} prompt={samplePrompts[active]} data-id="element-250" data-mp="dwbak77kpuiz" />
          </div>
        </div>
      </div>
    </section>;
}